/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import colors from "assets/theme/base/colors";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { agregarCeros } from "utils/truncate";

const estadosRecibir = ["Enviado", "Recibo parcial"];

const getRows = (data, accion) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        numero: (
          <SoftBox display="flex" alignItems="center">
            <SoftBox pr={0.2}>
              <Icon fontSize="small">
                {item?.estado === "Recibo parcial" ? "pause" : "receipt"}
              </Icon>
            </SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.estado === "Enviado" || item?.estado === "Recibido"
                ? agregarCeros(item.codigoSucursal, 4) + "-" + item.numero
                : item?.estado === "Recibo parcial"
                ? agregarCeros(item.codigoSucursal, 4) + "-" + item.numero + " - En pausa"
                : "En pausa"}
            </SoftTypography>
          </SoftBox>
        ),
        sucursal: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.sucursal ? item?.sucursal : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        destino: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.sucursal_destino ? item?.sucursal_destino.name : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        fecha: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.fecha ? dayjs(item.fecha).format("DD-MM-YYYY HH:mm") : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="subtitle2">
              {item?.estado ? (item?.estado === "Enviado" ? "Pendiente" : item?.estado) : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox mr={2} display="flex" flexDirection="row" justifyContent="flex-end">
            {estadosRecibir.includes(item.estado) && (
              <Tooltip title="Recibir productos" placement="top">
                <Icon
                  fontSize="large"
                  color="primary"
                  sx={{
                    cursor: "pointer",
                    // color: colors.primary.focus,
                  }}
                  onClick={() => accion("recibir", item)}
                >
                  download
                </Icon>
              </Tooltip>
            )}
            {item.estado === "Recibido" && (
              <Tooltip title="Ver remito" placement="top">
                <Link
                  to={`/remito/${item.id}`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                  }}
                >
                  <Icon
                    fontSize="large"
                    sx={{
                      cursor: "pointer",
                      color: colors.primary.focus,
                    }}
                  >
                    visibility
                  </Icon>
                </Link>
              </Tooltip>
            )}
          </SoftBox>
        ),
        backgroundColor: estadosRecibir.includes(item.estado) ? "#FFF2CC" : null,
      });
    });
  }

  return rows;
};

const columns = [
  { name: "numero", desc: "N° Remito", align: "left" },
  { name: "sucursal", desc: "Sucursal", align: "left" },
  { name: "destino", desc: "Destino", align: "left" },
  { name: "fecha", desc: "Fecha", align: "center" },
  { name: "estado", desc: "Estado", align: "left" },
  { name: "accion", desc: " ", align: "right", width: "1%", noOrder: true },
];

export default { columns, getRows };
